import { InsightData } from 'schemas/action/InsightDataSchema'
import { Filter } from 'schemas/FilterSchema'
import { DayAndHourWidgetsType } from 'components/widget/DayAndHourWidgets/types'

import { SearchFilterComposingStrategy } from './searchFilterComposingStrategy'
import { getRangeConfig, transformFilterPublishedDate } from '../utils/dayHours'

const composeDetailSearchFilter = (
  filter: Filter,
  insights: InsightData[],
  widgetSetting?: DayAndHourWidgetsType
) => {
  const transformedFilter = transformFilterPublishedDate(filter, widgetSetting!)

  return {
    ...transformedFilter,
    dayHours: [
      ...(transformedFilter.dayHours || []),
      {
        ...getRangeConfig(insights),
        timeZone: widgetSetting?.timeZoneOption
      }
    ]
  }
}

const generateDayHoursStrategy = (): SearchFilterComposingStrategy<DayAndHourWidgetsType> => ({
  composeDetailSearchFilter
})

export default generateDayHoursStrategy
